/* ATP Photos: reads the background colour of each product photo and gives its tile the same colour,
   so light garments never disappear into the tile. Photos with a busy background fill the tile instead. */
(function () {
  'use strict';
  var d = document, cache = {};
  var SPOTS = [
    { sel: '.product-card-reveal-image' },
    { sel: '.card-product--image' },
    { sel: '.product-media-image' },
    { sel: '.gallery-slider--thumbnail' },
    { sel: '.lightbox-thumbnail' },
    { sel: '.section-featured-product .image-with-text--image .image-cover-wrapper' },
    { sel: '.cart-item__image-wrapper' }
  ];
  var ALL = SPOTS.map(function (s) { return s.sel; }).join(',');

  function small(url) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=48');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=48';
  }
  function key(url) { return (url || '').split('?')[0]; }

  function read(url, done) {
    var k = key(url);
    if (!k) return done(null);
    if (cache[k] !== undefined) { if (cache[k] && cache[k].then) cache[k].then(done); else done(cache[k]); return; }
    var resolve; cache[k] = { then: function (fn) { (cache[k].q = cache[k].q || []).push(fn); } };
    var finish = function (res) { var q = cache[k].q || []; cache[k] = res; done(res); q.forEach(function (fn) { fn(res); }); };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var n = 24, c = d.createElement('canvas'); c.width = c.height = n;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, n, n);
        var px = x.getImageData(0, 0, n, n).data;
        var pts = [[0, 0], [n - 1, 0], [Math.floor(n / 2), 0], [0, n - 1], [n - 1, n - 1], [0, Math.floor(n / 3)], [n - 1, Math.floor(n / 3)]];
        var s = [0, 0, 0], vals = [];
        pts.forEach(function (p) { var i = (p[1] * n + p[0]) * 4; vals.push([px[i], px[i + 1], px[i + 2]]); s[0] += px[i]; s[1] += px[i + 1]; s[2] += px[i + 2]; });
        var avg = s.map(function (v) { return Math.round(v / pts.length); });
        var dev = 0;
        vals.forEach(function (v) { dev = Math.max(dev, Math.abs(v[0] - avg[0]) + Math.abs(v[1] - avg[1]) + Math.abs(v[2] - avg[2])); });
        finish({ uniform: dev < 30, color: 'rgb(' + avg.join(',') + ')', lum: Math.max(1, 0.2126 * avg[0] + 0.7152 * avg[1] + 0.0722 * avg[2]) });
      } catch (e) { finish(null); }
    };
    im.onerror = function () { finish(null); };
    im.src = small(url);
  }

  function apply(img) {
    if (!img || img.tagName !== 'IMG') return;
    var box = img.closest(ALL);
    if (!box) return;
    var url = img.currentSrc || img.src;
    if (!url || url.indexOf('data:') === 0 || img.__atpUrl === key(url)) return;
    img.__atpUrl = key(url);
    read(url, function (res) {
      if (img.__atpUrl !== key(url)) return;
      // keep the tile as it is if the photo could not be read
      if (!res) return;
      var holder = img.closest('.product-card-reveal-image') || box;
      holder.classList.remove('atp-studio', 'atp-scene'); holder.style.filter = '';
      if (res.uniform) {
        holder.style.setProperty('--atp-tile', res.color); holder.style.backgroundColor = res.color; holder.classList.add('atp-studio');
        // on cards and in the cart, even out the tiles: every studio background lands on the same soft warm tone
        if (holder.closest('.card-product--image, .cart-item__image-wrapper')) {
          var k = Math.max(0.9, Math.min(1.08, 236 / res.lum));
          holder.style.filter = 'brightness(' + k.toFixed(3) + ') sepia(.07)';
        }
      }
      else holder.classList.add('atp-scene');
    });
  }

  function scan(root) {
    var imgs = (root || d).querySelectorAll ? (root || d).querySelectorAll(SPOTS.map(function (s) { return s.sel + ' img'; }).join(',')) : [];
    Array.prototype.forEach.call(imgs, function (img) { if (img.complete && img.naturalWidth) apply(img); });
  }

  // every image load on the page, including lazy loads and variant changes
  d.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') apply(e.target); }, true);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  // cart drawer and quick add re-render their images
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); }, 120); }).observe(d.documentElement, { childList: true, subtree: true });
  }
})();
